// extracted by mini-css-extract-plugin
export default {"container":"bill_container__WBqIQ"};